<template>
    <div>
      <div class="card-block">
        <b-avatar class="mr-3 mt-2" style="float: left">
          <i class="fas fa-user-tie" style="font-size: 18px"></i>
        </b-avatar>
        <div>
          <strong>{{$t('associates.administrator')}}:<br /></strong>
          {{
                          objSelected && objSelected.gerente
                            ? objSelected.gerente.pessoa.nome
                            : 'NÃO INFORMADO'
                        }}
        </div>

        <div align="center" v-if="
                          objSelected &&
                            objSelected.historicoGerente &&
                            objSelected.historicoGerente.length > 0
                        "
                      >
          <b-button v-b-toggle.historicoGerenteAlteracao class="mt-1">
            Mostrar Alterações
          </b-button>

          <b-collapse id="historicoGerenteAlteracao" class="pt-3">
            <div>
              <tables
                ref="tableGrid"
                :showHeader="false"
                :columns="['DATA', 'NOME GERENTE']"
                :showPaging="false"
                :showTipFooter="false"
              >
                <tr v-for="(alt, index) in objSelected.historicoGerente" :key="index + 'PA'">
                  <TableColumn
                    :style="'font-size: 12px'"
                    :IsText="true"
                    :status="1"
                    :value="formatDateTimeForms(alt.dataInicio)"
                  />
                  <TableColumn
                    :style="'font-size: 12px'"
                    :IsText="true"
                    :status="1"
                    :value="alt.funcionario"
                  />
                </tr>
              </tables>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
  </template>

<script>
import AssociatePage from '@/views/private/associate/pages/AssociatePage.vue'
export default {
  name: 'AssociateGerente',
  components: {
    AssociatePage
  },
  props: {
    objSelected: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
  },
  methods: {
    formatDateTimeForms (obj) {
      return obj
        .split('T')[0]
        .split('-')
        .reverse()
        .join('/')
    }
  }
}
</script>

  <style scoped>
  .card {
    margin: 10px;
  }
  .card-block {
    padding: 20px;
  }
  </style>



// WEBPACK FOOTER //
// src/views/private/associate/components/AssociateGerente.vue